import { Components as JoyComponents, Theme as JoyTheme } from '@mui/joy';
import { tabClasses } from '@mui/joy/Tab';

export const overrides: JoyComponents<JoyTheme> = {
  JoyTab: {
    defaultProps: { color: 'primary', variant: 'soft' },
    styleOverrides: {
      root: ({ ownerState, theme }) => {
        return {
          ...(ownerState.variant === 'soft' && {
            '--Tab-color': theme.palette.neutral[400],
            color: 'var(--Tab-color)',
            borderRightColor: theme.palette.neutral[200],
            backgroundColor: theme.palette.common.white,
            [`&:not(${tabClasses.selected}):hover`]: {
              '--Tab-color': theme.palette.primary.softColor,
              '--variant-softHoverBg': theme.palette.primary[50],
              '--variant-softHoverColor': theme.palette.primary[600],
            },
            [`&.${tabClasses.selected}`]: {
              '--Tab-color': theme.palette.neutral[800],
              '--variant-softActiveBg': theme.palette.primary[50],
            },
          }),
        };
      },
    },
  },
  JoyTabList: {
    styleOverrides: {
      root: ({ ownerState, theme }) => {
        return {
          ...(ownerState.size === 'md' && {
            '--ListItem-paddingY': theme.spacing(1.25),
          }),
        };
      },
    },
  },
};

export { default as Tabs } from '@mui/joy/Tabs';
export { default as Tab } from '@mui/joy/Tab';
export { default as TabList } from '@mui/joy/TabList';
export { default as TabPanel } from '@mui/joy/TabPanel';
